import React from "react";
import PropTypes from "prop-types";

import {DefaultRule} from "./DefaultRule";
import {TemporalRules} from "./TemporalRules"
import {NoRules} from "./NoRules";

import {Fab, Grid, Typography} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

const CardBody = props => {
    const {rule, temporalRules, attributes, onCreate, onShowRequests, onDelete} = props;
    const {ruleType, temporalRuleType, ruleTitle, temporalRulesTitle, temporalRulesSubtitle} = attributes;

    const isTemporal = temporalRuleType > 0;
    const showCreateBtn = isTemporal || !rule;

    if (!rule && temporalRules.length === 0) {
        return (
            <NoRules onCreate={onCreate}/>
        )
    } else {
        return (
            <Grid container
                  direction="column"
                  justifyContent="space-between"
                  alignItems="stretch"
                  sx={{minHeight: '100%'}}>

                {(ruleType && rule) &&
                <Grid item
                      container
                      direction="column"
                      wrap='nowrap'
                      sx={{mb: 2}}>

                    <Grid item>
                        <Typography variant="h5">
                            {ruleTitle}
                        </Typography>
                    </Grid>

                    <Grid item>
                        <DefaultRule
                            rule={rule}
                            onShowRequests={onShowRequests}
                            onDelete={onDelete}
                        />
                    </Grid>

                </Grid>
                }

                {(temporalRuleType && temporalRules.length > 0) &&
                <Grid item
                      container
                      direction="column"
                      wrap='nowrap'
                      sx={{mb: 2}}>

                    <Grid item>
                        <Typography variant="h5">
                            {temporalRulesTitle}
                        </Typography>
                    </Grid>

                    <Grid item>
                        <TemporalRules
                            rules={temporalRules}
                            text={temporalRulesSubtitle}
                            onShowRequests={onShowRequests}
                            onDelete={onDelete}
                        />
                    </Grid>
                </Grid>
                }

                {showCreateBtn &&
                <Grid item
                      container
                      justifyContent="flex-end"
                      alignItems="flex-end"
                      sx={{mt: 2}}>
                    <Grid item>
                        <Fab size="medium"
                             variant="extended"
                             aria-label="Crea nuovo"
                             color='primary'
                             onClick={onCreate}>
                            <AddIcon/>
                            Crea
                        </Fab>
                    </Grid>
                </Grid>
                }
            </Grid>
        )
    }
};

CardBody.propTypes = {
    rule: PropTypes.object,
    temporalRules: PropTypes.arrayOf(PropTypes.object).isRequired,
    attributes: PropTypes.object.isRequired,
    onCreate: PropTypes.func.isRequired,
    onShowRequests: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
};

export {CardBody};